import { Injectable } from "@angular/core";
import { ApiService } from "./api";
import { AccountGroup } from "model/accountGroup";

@Injectable()
export class AccountGroupService {
    constructor(private api: ApiService) { }
    
    async getRodeoStaff(rodeoId: number) {
        return this.api.getWithAuth<AccountGroup[]>(`${this.api.endpoints.accountGroups}/getAllForRodeo?rodeoId=${rodeoId}`)
    }

    async create(item: AccountGroup) {
        return this.api.postWithAuth<AccountGroup>(`${this.api.endpoints.accountGroups}/create`, item);
    }


    async update(item: AccountGroup) {
        return this.api.postWithAuth<AccountGroup>(`${this.api.endpoints.accountGroups}/update`, item);
    }

    async delete(id: number) {
        return this.api.postWithAuth(`${this.api.endpoints.accountGroups}/delete?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/services/accountGroup.service.ts